// eslint does not know about the `process` global
/* eslint-disable no-undef */

export const XGRID_LICENSE_KEY = import.meta.env.VITE_XGRID_LICENSE_KEY;
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
export const PUBLIC_API_KEY = import.meta.env.VITE_PUBLIC_API_KEY || '';
export const PUBLIC_NONPROFIT_ENDPOINT =
  import.meta.env.VITE_PUBLIC_NONPROFIT_ENDPOINT || '';
export const PUBLIC_RECAPTCHA_SITE_KEY =
  import.meta.env.VITE_PUBLIC_RECAPTCHA_SITE_KEY || '';
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
export const ENV = import.meta.env.VITE_ENV;
export const isDevelopment = ENV === 'DEVELOPMENT';
export const isStaging = ENV === 'STAGING';
export const isProduction = ENV === 'PRODUCTION';
export const BUCKET_NAME = !isProduction
  ? 'dev-assets.careitapp.com'
  : 'assets.careitapp.com';

export const S3_BASE_URL = 'https://s3-us-west-2.amazonaws.com';

export const LANG_SETTINGS = import.meta.env.VITE_LANG_SETTINGS === '1';

export const MAX_ALLOWED_INSPECTION_PHOTOS = 10;
export const MAX_ALLOWED_INSPECTION_FILE_SIZE = 20 * 1024 * 1024; // 20MB

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const MAX_ALLOWED_INSPECTION_DOCUMENTS = 5;

export const ENABLE_CREATE_DONATION_PARTIAL = true;

export const ENABLE_MULTIPLE_DRIVERS = true;
